import { azimuthToRadians, degreesToRadians, radiansToAzimuth } from "./mathUtilities";

function getAzimuthAngle(stations: any[], index: number): number {
    const deltaX = stations[index].x - stations[index - 1].x;
    const deltaY = stations[index].y - stations[index - 1].y;

    const angleRadians = Math.atan2(deltaY, deltaX);

    return radiansToAzimuth(angleRadians);
}


function calcTangentCircle(stations: any[], index: number, radius: number): { centerX: number; centerY: number; } {

    // IMPORTANT: Do NOT remove commmented out lines in the function. They could be of use in the future.
    const currentAz = getAzimuthAngle(stations, index + 1);
    const previousAz = getAzimuthAngle(stations, index);
    let deflection = currentAz - previousAz;

    if (Math.abs(deflection) > 180.0) {
        // Since |deflection| <= 180 by definition, this case should be impossible
        if (deflection < 0.0)
            deflection = 360.0 - Math.abs(deflection);

        else
            deflection = deflection - 360.0;
    }

    const angleI = deflection;

    const hdaRadians = degreesToRadians(angleI) / 2.0;

    const tangentLength = Math.abs(radius * Math.tan(hdaRadians));
    // const curveLength = Math.abs(radius * degreesToRadians(angleI));

    // const deltaX = stations[index-1].x - stations[index].x;
    // const deltaY = stations[index-1].y - stations[index].y;
    // const getDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    // const distanceBeforePC = getDistance - tangentLength;

    const inboundToPI = azimuthToRadians(getAzimuthAngle(stations, index));

    const pcX = stations[index].x - tangentLength * Math.cos(inboundToPI);
    const pcY = stations[index].y - tangentLength * Math.sin(inboundToPI);

    // const outboundFromPI = azimuthToRadians(getAzimuthAngle(stations, index=1));

    // const ptX = stations[index].x + tangentLength * Math.cos(outboundFromPI);
    // const ptY = stations[index].y + tangentLength * Math.sin(outboundFromPI);

    const sign = Math.sign(angleI);
    const centerX = pcX + radius * Math.cos(inboundToPI - sign * Math.PI / 2.0);
    const centerY = pcY + radius * Math.sin(inboundToPI - sign * Math.PI / 2.0);

    return { centerX, centerY }

}

export { calcTangentCircle }